export const REFERENCE_TIMEZONE = 'Pacific/Honolulu';

export const DEFAULT_MAX_APRS = 1;
